var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('el-dialog',_vm._g(_vm._b({class:_vm.$style.dialog,attrs:{"visible":_vm.visible,"width":"374px"},on:{"update:visible":function($event){_vm.visible=$event}}},'el-dialog',_vm.$attrs,false),_vm.$listeners),[_c('login-swiper',{on:{"login-success":_vm.onLoginSuccess,"register-success":_vm.onLoginSuccess}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }